export function toFixed(input: number): number {
    if (input > 0) {
        return Math.floor(input);
    }

    return Math.ceil(input);
}

export function toDp(input: number, decimalPlaces: number): number {
    const multiplier = Math.pow(10, decimalPlaces);

    return Math.round(toFixed(input * multiplier * 10) / 10) / multiplier;
}
